export const ADD_TO_TAG = "ADD_TO_TAG";
export const DEL_TAG = "DEL_TAG";
export const CURRENT_NAME = "CURRENT_NAME";
export const CLEAR_CURRENT_NAME = "CLEAR_CURRENT_NAME";
export const CLEAR_TABS = "CLEAR_TABS";

export const LOGIN = "LOGIN";
export const LOGIN_OUT = "LOGIN_OUT";

export const CREATE_CONTROL = "CREATE_CONTROL";
export const CREATE_CLONE_CONTROL = "CREATE_CLONE_CONTROL";
export const UP_CONTROL = "UP_CONTROL";
export const DOWN_CONTROL = "DOWN_CONTROL";
export const DEL_CONTROL = "DEL_CONTROL";
export const DETIAL_CONTROL = "DETIAL_CONTROL";

export const QUERY_VIEW = "QUERY_VIEW";

export const RESET_STATE = "RESET_STATE";

export const EDIT_IMAGE = "EDIT_IMAGE";
